// Vendors
import styled from 'styled-components';
// Constants
import { COBRANDED_LIGHT_REGULAR_BASE_STYLES } from '@openbank/ziniaweb-ui-components';

const LayoutBottomSideFooterComponentStyled = styled.footer<{ paddingContent?: boolean }>`
  padding: ${({ theme }) => theme.spacing_250} 0;

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    padding: ${({ theme }) => theme.spacing_250}
      ${({ paddingContent, theme }) => (paddingContent ? '0' : theme.spacing_300)};
  }
`;
LayoutBottomSideFooterComponentStyled.displayName = 'LayoutBottomSideFooterComponentStyled';

export { LayoutBottomSideFooterComponentStyled };
